// extracted by css-extract-rspack-plugin
module.exports =  {"emptyStateContainer":"DocumentsEmptyState__emptyStateContainer___bihsH","emptyState":"DocumentsEmptyState__emptyState___CK6as"};